import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import ContextConfigFormNameField from "components/ContextConfigForm/NameField";
import FormDescriptionField from "components/Environment/components/FormItems/DescriptionField";
import FormIsSecretField from "components/Environment/components/FormItems/IsSecretField";
import FormValueField from "components/Environment/components/FormItems/ValueField";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import Card from "ds/components/Card";

import { ContextAttachedVariable, ContextFormFields } from "../types";

type ContextVariablesEditFormProps = {
  onSave: (item: ContextAttachedVariable) => void;
  index: number;
};

const ContextVariablesEditForm = ({ index, onSave }: ContextVariablesEditFormProps) => {
  const {
    handleSubmit,
    formState: { isValid },
    watch,
  } = useFormContext<ContextFormFields>();

  const onSubmit = useCallback(
    () =>
      handleSubmit((formData: ContextFormFields) => onSave(formData["attachedVariables"][index]))(),
    [onSave, index, handleSubmit]
  );

  return (
    <Card variant="secondary">
      <Box gap="medium" fullWidth margin="0 0 large">
        <ContextConfigFormNameField name={`attachedVariables.${index}.variableName`} />
        <FormValueField
          name={`attachedVariables.${index}.value`}
          isSecret={watch(`attachedVariables.${index}.isSecret`)}
        />
      </Box>

      <FormIsSecretField name={`attachedVariables.${index}.isSecret`} />

      <FormDescriptionField name={`attachedVariables.${index}.description`} />

      <Box justify="end" fullWidth margin="large 0 0">
        <Button variant="contrast" type="submit" onPress={onSubmit} disabled={!isValid}>
          Save
        </Button>
      </Box>
    </Card>
  );
};

export default ContextVariablesEditForm;
